<template>
  <div class="header b-flex b-justify-center b-align-centenr">
    <div class="content b-flex b-justify-between b-align-centenr">
      <img class="logo" src="https://image.ceekee.com/pc/secondwebsite/logo.png" />
      <div class="b-flex b-flex-row b-align-centenr">
        <div class="types b-flex b-flex-row b-align-centenr">
          <div class="item" @click="toIndex">
            首页
            <div class="current" v-if="type == 1"></div>
          </div>
          <div class="item" @click="toProduct">
            产品中心
            <div class="current" v-if="type == 2"></div>
          </div>
          <div class="item" @click="toOur">
            商务合作
            <div class="current" v-if="type == 3"></div>
          </div>
        </div>
        <div class="button b-flex b-align-centenr b-justify-center"><span @click="toRegister">注册</span>/<span @click="toLogin">登录</span></div>
      </div>
    </div>
    <topleft></topleft>
  </div>
</template>

<script>
import topleft from "@/components/left"
export default {
  components: {
    topleft
  },
  props:['type'],
  methods:{
    toLogin(){
      this.$router.push("/login");
    },
    toRegister(){
      this.$router.push("/register");
    },
    toProduct(){
      this.$router.push("/productscheme");
    },
    toIndex(){
      this.$router.push("/");
    },
    toOur(){
      this.$router.push("/business");
    },
    toApply(){
      this.$router.push("/apply");
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  width: 100%;
  height: 128px;
  background:url(https://image.ceekee.com/pc/secondwebsite/dingwei_bg.png) no-repeat;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  .logo {
    height: 43px;
    width: 178px;
  }
  .content {
    width: 1040px;
    color: #fff;
    margin: 0 auto;
    .tripwise {
      font-size: 32px;
    }
    .types {
      font-size: 16px;
      .item {
        margin-right: 40px;
        height: 22px;
        cursor: pointer;
      }
      .current {
        margin-top: 2px;
        width: 100%;
        height: 4px;
        background: #ffffff;
        border-radius: 2px;
      }
    }
    .button {
      margin-left: 100px;
      width: 138px;
      height: 42px;
      background: #ffffff;
      font-size: 16px;
      color: #0376f7;
      font-weight: 400;
      border-radius: 21px;
      cursor: pointer;
    }
  }
}

</style>